import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=0e2b0332&scoped=true&"
import script from "./NoticeList.vue?vue&type=script&lang=js&"
export * from "./NoticeList.vue?vue&type=script&lang=js&"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=0e2b0332&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2b0332",
  null
  
)

export default component.exports